import GlobalAxios from "../axios/axios-config";
import { IMySchedulesPortal } from "../models/my-schedule-portal";

const MY_SCHEDULES_PORTAL_ROUTE =
  process.env.REACT_APP_CALENDAR +
  "/api/v2/tasy/MyAppointment/MySchedulesPortal";

const MY_APPOINTMENTS_ROUTE =
  process.env.REACT_APP_CALENDAR + "/api/v2/tasy/MyAppointment";

export const getMyAppointments = ({
  historic,
  showFamilyGroup,
  ticketAutomationReceivedRuleId,
}: {
  historic?: boolean;
  showFamilyGroup?: boolean;
  ticketAutomationReceivedRuleId?: string | null;
}) => {
  return GlobalAxios.get<IMySchedulesPortal[]>(MY_APPOINTMENTS_ROUTE, {
    params: {
      historic,
      showFamilyGroup,
      ticketAutomationReceivedRuleId,
    },
  });
};

export const getMySchedulesPortal = ({
  identifier,
  historic,
  firstGet,
}: {
  identifier?: string;
  historic?: boolean;
  firstGet?: boolean;
}) => {
  return GlobalAxios.get<IMySchedulesPortal[]>(MY_SCHEDULES_PORTAL_ROUTE, {
    params: {
      identifier,
      historic,
      firstGet,
    },
  });
};
